__webpack_require__.p = "/widgets/upload-artwork/2.2.0.e99593c/";